import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";
import checkIconRed from "../../../resources/images/alert-circle.svg";

const styles = createUseStyles(theme => ({
  modalContent: {
    margin: "20px 0 0 0"
  },
  editPolicyModal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "28px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    "& .modal-body": {
      padding: "8px 24px",

    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  btnContainer:{
    marginTop: "32px",
    marginBottom: "16px"
  },

  inputContainer:{
    display: "flex",
    flexDirection: "column",
    "& input":{
      height: "44px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      "&:focus": {
        outline: "none"
      }
    },
    "& .input-error":{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      paddingRight: "35px",
      border: "1px solid " + colors.mediumRed,
      backgroundSize: "16px 16px",
      backgroundPosition: "right -25px center", 
      backgroundRepeat: "no-repeat",
      backgroundOrigin: "content-box",
      backgroundImage: `url(${checkIconRed})`
    },
  },

  cancelBtn: {
    height: "100%",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
  },
  saveBtn: {
    height: "100%",
    alignItems: "center",
    width:"100%",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "20px",
    fontFamily: theme.fontFamily,
  },
  colCancel:{
    padding: 0,
    marginRight: "6px"
  },
  colSave:{
    padding: "0px",
    marginLeft: "6px"
  },
  label:{
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    color: colors.grey,
    marginBottom: "6px"
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    }
  },
  nameError: {
    fontSize: "14px",
    fontWeight: 400,
    color: colors.red,
    marginTop: "6px"
  },
}));

export default styles;